"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimCareTeam = void 0;
/**
 * A provider issued list of professional services and products which have been provided, or are to be provided, to a patient which is sent to an insurer for reimbursement.
 */
var ClaimCareTeam = /** @class */ (function () {
    function ClaimCareTeam() {
    }
    return ClaimCareTeam;
}());
exports.ClaimCareTeam = ClaimCareTeam;
